import React from "react";
import { withRouter } from "react-router-dom";
import { gql } from "@apollo/client";
import { apolloClient } from "../../../index";

import "./NotificationIcon.scss";
import notification from "../../../assets/icons/header/notification.svg";
import Spinner from "react-bootstrap/Spinner";
import { getName, getIntials, getParsedDate } from "../../../helper";
import emptyNotifications from "../../../assets/EmptyStates/empty_notifications.svg";
import ShareWithDetails from "../../SharedWith/SharedWithDetails/SharedWithDetails";
import { notify } from "../../Notify/Notify";
import EmptyStates from "../../EmptyStates/EmptyStates";

export default withRouter(
  class NotificationIcon extends React.Component {
    constructor(props) {
      super(props);

      this.state = {
        showNotificationDialog: false,
        totalUnreadNotifications: props.unReadCount,
        notifications: props.notifications,
        isLoading: false,
        totalVisibleNotifications: 6,
      };

      this.notificationRef = React.createRef();
      this.handleClickOutsideOfNotification = this.handleClickOutsideOfNotification.bind(this);
    }
    componentDidUpdate(prevProps) {
      if (prevProps !== this.props) {
        let count = 0;
        this.props.notifications.map((item) => (item.isRead ? null : (count = count + 1)));
        this.setState({
          notifications: this.props.notifications,
          totalUnreadNotifications: count,
        });
      }
    }

    componentDidMount() {
      document.addEventListener("mousedown", this.handleClickOutsideOfNotification);
    }

    componentWillUnmount() {
      document.removeEventListener("mousedown", this.handleClickOutsideOfNotification);
    }

    handleClickOutsideOfNotification(event) {
      if (
        this.notificationRef &&
        this.notificationRef.current &&
        !this.notificationRef.current.contains(event.target)
      ) {
        this.setState({ showNotificationDialog: false });
      }
    }

    openNotificationDialog = () => {
      let isOpen = !this.state.showNotificationDialog;
      if (isOpen) {
        this.setState({ showNotificationDialog: isOpen });
        this.loadNotifications();
      } else {
        this.closeNotificationDialog();
      }
    };

    loadNotifications = () => {
      //hit backend to unread notification
      const notificationList = [];
      let notification = this.props.notifications;
      notification.map((item) => notificationList.push(item.id));
      const variables = {
        notificationList: notificationList,
      };

      apolloClient
        .mutate({
          mutation: gql`
            mutation readNotification($notificationList: [String]) {
              readNotification(notificationList: $notificationList) {
                success
              }
            }
          `,
          variables: variables,
        })
        .then((result) => {
          let notifications = this.props.notifications;
          notifications.map((item) => (item.isRead = true));
          this.setState({
            notifications,
            totalUnreadNotifications: 0,
          });
        })
        .catch(() => {});
    };

    navigateToFolder = (folder) => {
      let routingPath = null;
      if (folder.inTrash) {
        // notify for error
        const detail = "Error";
        const title = "Folder has been deleted";
        const type = "error";
        notify(detail, title, type);
        return;
      }
      routingPath = folder.isRoot
        ? (routingPath = !folder.isArchive ? `/files/${folder.id}` : `/archives/${folder.id}`)
        : (routingPath = !folder.isArchive
            ? `/files/${folder.parentFolder.id}/${folder.id}`
            : `/archives/${folder.parentFolder.id}/${folder.id}`);

      if (routingPath) {
        this.closeNotificationDialog();
        this.props.history.push(routingPath);
      }
    };

    getSentance = (action, isFolder, isTypeOfDocument, isTag) => {
      switch (action) {
        case "Created":
          return isFolder ? "a new folder" : "";
        case "Added":
          return isTypeOfDocument ? "a new template" : isTag ? "a new tag" : "";
        case "Updated":
          return isTypeOfDocument ? "a template" : "";
        case "Activated":
            return isTypeOfDocument ? "a template" : "";
        case "Deactivated":
          return isTypeOfDocument ? "a template" : "";
        case "Deleted":
          return isTypeOfDocument ? "a template" : isTag ? "a tag" : "";
        default:
          return "";
      }
    };

    getNotificationsJSX = () => {
      let notificationsList = [...this.state.notifications];
      return notificationsList.splice(0, this.state.totalVisibleNotifications).map((notificationObj) => {
        const { id, folder, typeOfDocument, tag, createdBy, action, createdTs } = notificationObj;
        let isFolder = folder ? true : false;
        let isTypeOfDocument = typeOfDocument ? true : false;
        let isTag = tag ? true : false;

        // To not display older non supported notifications
        return (isFolder && action.name === "Created") || isTypeOfDocument || isTag ? (
          <div
            key={id}
            className={`notification-slide ${isFolder ? "notification-link" : ""}`}
            onClick={isFolder ? () => this.navigateToFolder(folder) : null}
          >
            <div className="notification-content">
              {/* <NavLink to={this.getRoutingPath(folder)}> */}
              <div className="d-flex">
                <ShareWithDetails
                  key={id}
                  sKey={id}
                  isPopover={true}
                  nameIntial={getIntials(createdBy)}
                  personName={getName(createdBy)}
                  profile={createdBy.profile.image}
                  role={createdBy.profile.role.name}
                />
                <p>
                  <span className="person pl-1">{getName(createdBy)}</span>
                  <span className="action">
                    {" "}
                    {action.name} {this.getSentance(action.name, isFolder, isTypeOfDocument, isTag)}{" "}
                  </span>
                  {isFolder ? (
                    <span className="doc">{folder.title}</span>
                  ) : isTypeOfDocument ? (
                    <span className="doc">{typeOfDocument.title}</span>
                  ) : isTag ? (
                    <span className="doc">{tag.name}</span>
                  ) : null}
                </p>
              </div>
              {/* </NavLink> */}
            </div>
            <div className="time-content">
              <span className="time">{getParsedDate(createdTs)}</span>
            </div>
          </div>
        ) : null;
      });
    };

    closeNotificationDialog = () => {
      this.setState({ showNotificationDialog: false });
    };

    viewAllNotificationsHandler = (e) => {
      e.preventDefault();
      this.setState({
        totalVisibleNotifications: this.state.notifications.length,
      });
    };

    render() {
      return (
        <div className="notification-icon-container" ref={this.notificationRef}>
          <div className="notification">
            <img
              className="notification-icon"
              onClick={this.openNotificationDialog}
              src={notification}
              alt="Notification"
            />
            {this.state.totalUnreadNotifications && this.state.totalUnreadNotifications > 0 ? (
              <span className="badge" onClick={this.openNotificationDialog}>
                {this.state.totalUnreadNotifications}
              </span>
            ) : null}
          </div>

          {this.state.showNotificationDialog ? (
            <div className={`notification-dialog-container ${this.state.showNotificationDialog ? "show" : "hide"}`}>
              <div className="header">
                <span className="title">Notifications</span>
              </div>
              <div className="notifications-container">
                {this.state.isLoading ? (
                  <div className="progress-icon">
                    <Spinner animation="border" role="status" />
                  </div>
                ) : this.state.notifications.length === 0 ? (
                  <div className="empty-body">
                    <EmptyStates
                      imgSrc={emptyNotifications}
                      emptyStateTitle="You’re off the hook!"
                      emptyStateButtons={[]}
                    />
                  </div>
                ) : (
                  <>
                    <div className="body">{this.getNotificationsJSX()}</div>

                    {!this.state.isLoading && this.state.totalVisibleNotifications < this.state.notifications.length ? (
                      <div className="footer">
                        <span onClick={this.viewAllNotificationsHandler}>View all</span>
                      </div>
                    ) : null}
                  </>
                )}
              </div>
            </div>
          ) : null}
        </div>
      );
    }
  }
);
